import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Divider,
} from "@mui/material";
import {useNavigate} from "react-router";

const ErrorPage403 = () => {
  const navigate = useNavigate();

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100vh"
      px={2}>
      <Card sx={{maxWidth: 500, textAlign: "center", p: 3}}>
        <CardContent>
          <Typography variant="h1" color="textDisabled" fontWeight="bold">
            403
          </Typography>
          <Typography
            variant="h5"
            color="textPrimary"
            sx={{mt: 1, fontWeight: "bold"}}>
            Access Forbidden
          </Typography>
          <Divider sx={{my: 3}} />
          <Typography variant="body1" color="textSecondary">
            You do not have permission to access this resource.
          </Typography>
          <Typography variant="body2" color="textSecondary" sx={{mt: 1}}>
            If you believe you should have access, please contact your system
            administrator.
          </Typography>
          <Button
            variant="contained"
            color="primary"
            onClick={() => navigate(-1)}
            sx={{mt: 3}}>
            Go Back
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
};

export default ErrorPage403;
